// Time units and refresh ages shared by the Workers that run a job and
// ../publisher's health check, which judges whether each job is keeping up.

export const HOUR_SECONDS = 3600;
export const DAY_SECONDS = 86400;

// The day-ago figures compare with the newest count or rank in this window
// before the day mark: the crawler misses hours, and the next one back is a
// truer comparison than none. Slack is the error in the "24h" the site
// labels it with, so it stays small. ../publisher and ./ranks.ts read it.
export const DAY_AGO_WINDOW = 6 * 3600;

// The start of the hour containing `time` (unix ms), in unix seconds: the
// hour ../crawler files a count under, and the others look it up by.
export function hourOf(time: number): number {
  return Math.floor(time / 3600000) * 3600;
}

// Store details (name, header image URL, store info) are refreshed at most
// once a day per app; the image URL's hash changes when a publisher updates
// their art. ../scheduler queues them, ../crawler fetches them.
export const DETAILS_MAX_AGE = DAY_SECONDS;

// Update announcements (Steam events labelled as updates) are re-checked at
// most once a day per app, so a new update shows up on the chart within a day.
export const UPDATES_MAX_AGE = DAY_SECONDS;

// Prices are checked every 3 hours, so a sale's start and end are right to
// within 3 hours. Hourly checks would be ~12,000 D1 row writes a day (a
// prices_checked_at stamp per app per check), too many beside the rest under
// the free plan's 100,000; every 3 hours is ~4,000. ../scheduler queues apps
// checked this long ago; ../publisher's health check counts apps not checked
// for longer than this (plus its grace).
export const PRICES_MAX_AGE = 3 * HOUR_SECONDS;

// ../publisher saves a health check at :10 and :30 (its cron), so at most 40
// minutes apart; ../web's GET /api/health reports one older than this as
// stale, meaning the publisher has stopped. Keep it above the cron's longest
// gap.
export const HEALTH_MAX_AGE = 3600;

// A price not checked for this long is no longer known: the app was made
// inactive, so the crawler stopped checking it, and a sale it was on can't be
// said to go on. ../web's game price and ../tagger's on_sale read it.
export const PRICE_KNOWN_FOR = DAY_SECONDS;
